import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ClientGridCollectionQuery, ClientGridCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ClientGridCollectionQuery)
@Wrapper(ClientGridCollectionQueryHandlerBase)
export class ClientGridCollectionQueryHandler {
    public constructor(
        http: Http,
    ) { }
}
